import type {
  APILibraryVerticalRequestType,
  APILibraryVerticalResponseType,
} from "@/core/data_sources/models/APILibraryVertical";
import type { BasicQuery } from "@/core/data_sources/services";
import { del, get, patch, post } from "@/core/utils/request";

export function getVerticals<Q extends BasicQuery>(query: Q) {
  void query;
  return get<APILibraryVerticalResponseType[]>("/library/verticals/", {
    params: query,
  });
}
export function getVerticalById(id: number) {
  return get<APILibraryVerticalResponseType>(`/library/verticals/${id}/`);
}
export function postVertical(data: APILibraryVerticalRequestType) {
  return post<APILibraryVerticalRequestType, APILibraryVerticalResponseType>(
    "/library/verticals/",
    data,
  );
}
export function patchVertical(
  id: number,
  data: Partial<APILibraryVerticalRequestType>,
) {
  return patch<
    Partial<APILibraryVerticalRequestType>,
    APILibraryVerticalResponseType
  >(`/library/verticals/${id}/`, data);
}
export function deleteVertical(id: number) {
  return del(`/library/verticals/${id}/`);
}
